import EntityInputField from 'vue-forms/components/EntityInputField';
import UserService from 'app/services/UserService';

export default {
  mixins: [ EntityInputField ],

  props: {
    service: {
      default: () => UserService
    },

    idField: {
      default: 'id'
    },
  },

  methods: {
    customLabel(item) {
      return item.displayName;
    },

    customTags(result) {
      //console.log('result', result);
      return result.workgroups.map(item => {
        const text = item.workgroup.name;
        let variant, help;
        if (item.type === 'ADMINISTRATOR') {
          variant = 'primary';
          help = `${result.displayName} è amministratore del gruppo ${item.workgroup.name}`;
        } else if (item.type === 'ORDINARY') {
          variant = 'success';
          help = `${result.displayName} è utente ordinario del gruppo ${item.workgroup.name}`;
        } else if (item.type === 'GUEST') {
          variant = 'warning';
          help = `${result.displayName} è ospite del gruppo ${item.workgroup.name}`;
        }
        return { text, variant, help };
      });
    }
  }
};
